/**
 * 平台菜单、路由
 */
export default {
  menuList: [
    {
      title: '概况',
      key: 'dataView', // 自定义key
      icon: 'line-chart',
      subMenu: [
        { title: '数据概览', route: 'allVis', key: 'dataView' }// 每个页面组件name
      ]
    },
    {
      title: '物业管理',
      key: 'property',
      icon: 'copyright',
      subMenu: [
        { title: '物业角色管理', route: 'propertyRole', key: 'property' },
        { title: '物业公司管理', route: 'company', key: 'property' },
        { title: '物业账号管理', route: 'propertyAccount', key: 'property' }
      ]
    },
    {
      title: '基础数据',
      key: 'database',
      icon: 'database',
      subMenu: [
        { title: '小区管理', route: 'community', key: 'database' },
        { title: '楼栋管理', route: 'building', key: 'database' },
        { title: '单元管理', route: 'unit', key: 'database' },
        { title: '房间管理', route: 'room', key: 'database' },
        { title: '位置管理', route: 'location', key: 'database' }
      ]
    },
    {
      title: '会员管理',
      key: 'members',
      icon: 'user',
      subMenu: [
        { title: '会员信息', route: 'member', key: 'members' },
        { title: '住户认证记录', route: 'householdAuthRecord', key: 'members' },
        { title: '社区身份证', route: 'passport', key: 'members' },
        { title: '人员预警', route: 'blackList', key: 'members' },
        { title: '人员预警记录', route: 'blackListRecord', key: 'members' }
      ]
    },
    {
      title: '设备管理',
      key: 'deviceManage',
      icon: 'layout',
      subMenu: [
        { title: '门禁设备', route: 'smartDoor', key: 'deviceManage' },
        { title: '钥匙申请记录', route: 'keyApply', key: 'deviceManage' },
        { title: '住户钥匙列表', route: 'keyList', key: 'deviceManage' },
        { title: '制卡记录', route: 'cardRecord', key: 'deviceManage' },
        { title: '开门日志', route: 'openLog', key: 'deviceManage' },
        { title: '位置分类', route: 'locationCate', key: 'deviceManage' },
        { title: '产品分类', route: 'productCate', key: 'deviceManage' },
        { title: '产品', route: 'product', key: 'deviceManage' },
        { title: '设备', route: 'device', key: 'deviceManage' },
        { title: '设备运行日志', route: 'devRunLog', key: 'deviceManage' }
      ]
    },
    {
      title: '运营管理',
      key: 'marketing',
      icon: 'dollar',
      subMenu: [
        { title: '系统消息', route: 'systemMsg', key: 'marketing' },
        { title: '消息模板', route: 'msgTemplate', key: 'marketing' },
        { title: '推送通知', route: 'push', key: 'marketing' },
        { title: '文档管理', route: 'document', key: 'marketing' },
        { title: 'APP广告', route: 'advert', key: 'marketing' },
        { title: '用户反馈', route: 'feedBack', key: 'marketing' },
        { title: '消息模板分类', route: 'msgtplCate', key: 'marketing' },
        { title: '文档分类', route: 'docCate', key: 'marketing' },
        { title: '平台优选', route: 'goodsWarehouse', key: 'marketing' },
        { title: '联盟活动', route: 'activity', key: 'marketing' }
      ]
    },
    {
      title: '霸屏管理',
      key: 'advScreen',
      icon: 'dollar',
      subMenu: [
        { title: '费用设置', route: 'priceSet', key: 'advScreen' },
        { title: '禁用小区', route: 'disabCommunity', key: 'advScreen' },
        { title: '订单管理', route: 'orderManage', key: 'advScreen' },
        { title: '财务明细', route: 'finance', key: 'advScreen' }
      ]
    },
    {
      title: '管理员中心',
      key: 'manageCenter',
      icon: 'team',
      subMenu: [
        { title: '管理员角色管理', route: 'role', key: 'manageCenter' },
        { title: '管理员账号管理', route: 'account', key: 'manageCenter' },
        { title: '管理员操作日志', route: 'operationLog', key: 'manageCenter' }
      ]
    },
    {
      title: '系统设置',
      key: 'setting',
      icon: 'setting',
      subMenu: [
        { title: '版本管理', route: 'appVersion', key: 'setting' },
        { title: '社区APP菜单', route: 'communityApp', key: 'setting' },
        { title: '管家APP菜单', route: 'stewardApp', key: 'setting' },
        { title: 'API分类', route: 'apiCate', key: 'setting' },
        { title: 'API管理', route: 'api', key: 'setting' }
      ]
    },
    {
      title: '工程管理',
      key: 'project',
      icon: 'setting',
      subMenu: [
        { title: '工程账号管理', route: 'projectAccount', key: 'project' }
      ]
    },
    {
      title: '政务账号体系',
      key: 'government',
      icon: 'setting',
      subMenu: [
        { title: '政务角色管理', route: 'govRole', key: 'government' },
        { title: '政务用户管理', route: 'govAccount', key: 'government' }
      ]
    }
  ],

  routes: [
    /** 霸屏 start */
    {
      path: '/priceSet',
      name: 'priceSet',
      menuKey: 'priceSet',
      component: () => import('@/components/advScreen//priceSet'),
      btnList: [
        {title: '确定', key: 'confirm'},
        { title: '取消', key: 'cancel' }
      ],
      meta: {title: '费用设置', breadNumber: 0}
    },
    {
      path: '/disabCommunity',
      name: 'disabCommunity',
      menuKey: 'disabCommunity',
      component: () => import('@/components/advScreen/disabCommunity/disabCommunity'),
      btnList: [
        {title: '新增', key: 'addbtn'},
        { title: '删除', key: 'delete' }
      ],
      meta: {title: '禁用小区', breadNumber: 0}
    },
    {
      path: '/disabCommunity/add',
      name: 'addDisab',
      menuKey: 'disabCommunity',
      component: () => import('@/components/advScreen/disabCommunity/addDisab'),
      btnList: [
        {title: '提交', key: 'submit'}
      ],
      meta: {title: '添加禁用小区', breadNumber: 1}
    },
    {
      path: '/finance',
      name: 'finance',
      menuKey: 'finance',
      component: () => import('@/components/advScreen/finance'),
      btnList: [
        {title: '详情', key: 'detail'}
      ],
      meta: {title: '财务明细', breadNumber: 0}
    },
    {
      path: '/orderManage',
      name: 'orderManage',
      menuKey: 'orderManage',
      component: () => import('@/components/advScreen/orderManage/index'),
      btnList: [
        {title: '退款', key: 'drawback'},
        {title: '详情', key: 'detail'},
        {title: '审核', key: 'examine'},
        {title: '上刊', key: 'publish'},
        {title: '重新退款', key: 'reDrawback'}
      ],
      meta: {title: '订单管理', breadNumber: 0}
    },
    {
      path: '/orderManage/detail',
      name: 'orderDetail',
      menuKey: 'orderManage',
      component: () => import('@/components/advScreen/orderManage/orderDetail'),
      btnList: [
        {title: '审核通过', key: 'pass'},
        {title: '审核拒绝', key: 'reject'}
      ],
      meta: {title: '订单详情', breadNumber: 1}
    },
    /** 霸屏 end */

    /** 营销1.1 start */
    {
      path: '/activity',
      name: 'activity',
      menuKey: 'activity',
      component: () => import('@/components/marketing/activity/activity'),
      btnList: [
        {title: '新增', key: 'addbtn'},
        { title: '推广', key: 'spread' },
        { title: '下载素材', key: 'download' },
        {title: '删除', key: 'delete'}
      ],
      meta: {title: '联盟活动', breadNumber: 0}
    },
    {
      path: '/devRunLog',
      name: 'devRunLog',
      menuKey: 'devRunLog',
      component: () => import('@/components/device/devRunLog'),
      btnList: [],
      meta: {title: '设备运行日志', breadNumber: 0}
    },
    /** 营销1.1 end */

    /** v3.3 start */
    {
      path: '/goodsWarehouse',
      name: 'goodsWarehouse',
      menuKey: 'goodsWarehouse',
      component: resolve => require(['../components/marketing/goodsWarehouse/goodsWarehouse'], resolve),
      btnList: [
        {title: '新增', key: 'addbtn'},
        { title: '修改', key: 'edit' },
        { title: '编辑商品', key: 'editGoods' },
        {title: '设为推荐', key: 'recommend'},
        {title: '删除', key: 'delete'}
      ],
      meta: {title: '选品库', breadNumber: 0}
    },
    {
      path: '/goodsWarehouse/add',
      name: 'addWarehouse',
      menuKey: 'goodsWarehouse',
      component: resolve => require(['../components/marketing/goodsWarehouse/addWarehouse'], resolve),
      btnList: [
        {title: '提交', key: 'submit'}
      ],
      meta: {title: '添加选品库', breadNumber: 1}
    },
    {
      path: '/goodsWarehouse/editGoods',
      name: 'editGoods',
      menuKey: 'goodsWarehouse',
      component: resolve => require(['../components/marketing/goodsWarehouse/editGoods'], resolve),
      meta: {title: '编辑商品列表', breadNumber: 1},
      btnList: [
        { title: '新增', key: 'addbtn' },
        { title: '导入', key: 'import' },
        { title: '淘宝抓取', key: 'fetch' },
        { title: '修改', key: 'edit' },
        { title: '推广', key: 'spread' },
        { title: '置顶', key: 'top' },
        { title: '删除', key: 'delete' }
      ]
    },
    {
      path: '/goodsWarehouse/editGoods/add',
      name: 'addGoods',
      menuKey: 'goodsWarehouse',
      component: resolve => require(['../components/marketing/goodsWarehouse/addGoods'], resolve),
      btnList: [
        {title: '提交', key: 'submit'}
      ],
      meta: {title: '添加商品', breadNumber: 2}
    },
    /** v3.3 end */

    {
      path: '/allVis',
      name: 'allVis',
      menuKey: 'allVis',
      component: resolve => require(['../components/dataVisual/allVis'], resolve),
      meta: {title: '浩邈智慧社区数据概览', breadNumber: 0}
    },
    {
      path: '/communityVis',
      name: 'communityVis',
      menuKey: 'allVis',
      component: resolve => require(['../components/dataVisual/communityVis'], resolve),
      meta: {title: '某社区数据概览', breadNumber: 0}
    },

    {
      path: '/blackList',
      name: 'blackList',
      menuKey: 'blackList',
      component: resolve => require(['../components/member/blackList/blackList'], resolve),
      btnList: [
        {title: '新增', key: 'addbtn'},
        {title: '开门日志', key: 'log'},
        {title: '修改', key: 'edit'},
        {title: '删除', key: 'delete'}
      ],
      meta: {title: '人员预警', breadNumber: 0}
    },
    {
      path: '/blackList/add',
      name: 'addBlackList',
      menuKey: 'blackList',
      component: resolve => require(['../components/member/blackList/addBlackList'], resolve),
      btnList: [
        {title: '提交', key: 'submit'}
      ],
      meta: {title: '添加人员', breadNumber: 1}
    },
    {
      path: '/blackList/log',
      name: 'lookOpenLog',
      menuKey: 'blackList',
      component: resolve => require(['../components/member/blackList/lookOpenLog'], resolve),
      btnList: [
        {title: '查看', key: 'show'}
      ],
      meta: {title: '开门日志', breadNumber: 1}
    },
    {
      path: '/blackListRecord',
      name: 'blackListRecord',
      menuKey: 'blackListRecord',
      component: resolve => require(['../components/member/blackList/blackListRecord'], resolve),
      btnList: [
        {title: '查看', key: 'show'}
      ],
      meta: {title: '人员预警记录', breadNumber: 0}
    },

    {
      path: '/govRole',
      name: 'govRole',
      menuKey: 'govRole', // 添加、编辑、详情页面的key都等于主页面的key(当一个二级菜单包含 > 1个页面时,多个页面归属到一个二级菜单下)
      component: resolve => require(['../components/government/role/govRole'], resolve),
      btnList: [
        {title: '新增', key: 'addbtn'},
        {title: '批量删除', key: 'batchDel'},
        {title: 'API权限', key: 'apiAuth'},
        {title: '视图权限', key: 'viewAuth'},
        {title: '修改', key: 'edit'},
        {title: '删除', key: 'delete'}
      ],
      meta: {title: '政务角色', breadNumber: 0}
    },
    {
      path: '/govRole/add',
      name: 'addGovrole',
      menuKey: 'govRole',
      component: resolve => require(['../components/government/role/addGovrole'], resolve),
      btnList: [
        {title: '提交', key: 'submit'}
      ],
      meta: {title: '新增政务角色', breadNumber: 1}
    },
    {
      path: '/govRole/api',
      name: 'govApiAuth',
      menuKey: 'govRole',
      component: resolve => require(['../components/managerCenter/role/roleAuth'], resolve),
      btnList: [
        {title: '提交', key: 'submit'}
      ],
      meta: {title: '配置api权限', breadNumber: 1}
    },
    {
      path: '/govRole/view',
      name: 'govViewAuth',
      menuKey: 'govRole',
      component: resolve => require(['../components/managerCenter/role/roleAuth'], resolve),
      btnList: [
        {title: '提交', key: 'submit'}
      ],
      meta: {title: '配置视图权限', breadNumber: 1}
    },
    {
      path: '/govAccount',
      name: 'govAccount',
      menuKey: 'govAccount',
      component: resolve => require(['../components/government/account/govAccount'], resolve),
      btnList: [
        {title: '新增', key: 'addbtn'},
        {title: '批量删除', key: 'batchDel'},
        {title: '状态切换', key: 'status'},
        {title: '重置密码', key: 'resetPwd'},
        {title: '修改', key: 'edit'},
        {title: '删除', key: 'delete'}
      ],
      meta: {title: '政务账号', breadNumber: 0}
    },
    {
      path: '/govAccount/add',
      name: 'addGovAccount',
      menuKey: 'govAccount',
      component: resolve => require(['../components/government/account/addGovAccount'], resolve),
      btnList: [
        {title: '提交', key: 'submit'}
      ],
      meta: {title: '新增政务账号', breadNumber: 1}
    },

    {
      path: '/projectAccount',
      name: 'projectAccount',
      menuKey: 'projectAccount',
      component: resolve => require(['../components/projectAccount/projectAccount'], resolve),
      btnList: [
        {title: '新增', key: 'addbtn'},
        {title: '批量删除', key: 'batchDel'},
        {title: '重置密码', key: 'resetPwd'},
        {title: '修改', key: 'edit'},
        {title: '删除', key: 'delete'}
      ],
      meta: {title: '工程账号管理', breadNumber: 0}
    },
    {
      path: '/projectAccount/add',
      name: 'addProjectAccount',
      menuKey: 'projectAccount',
      btnList: [
        {title: '提交', key: 'submit'}
      ],
      component: resolve => require(['../components/projectAccount/addProjectAccount'], resolve),
      meta: {title: '新增工程账号', breadNumber: 1}
    },
    {
      path: '/document',
      name: 'document',
      menuKey: 'document',
      btnList: [
        {title: '新增', key: 'addbtn'},
        {title: '修改', key: 'edit'},
        {title: '删除', key: 'delete'}
      ],
      component: resolve => require(['../components/marketing/document/document'], resolve),
      meta: {title: '文档管理', breadNumber: 0}
    },
    {
      path: '/document/add',
      name: 'addDocument',
      menuKey: 'document',
      btnList: [
        {title: '提交', key: 'submit'}
      ],
      component: resolve => require(['../components/marketing/document/addDocument'], resolve),
      meta: {title: '文添加档', breadNumber: 1}
    },
    {
      path: '/appVersion',
      name: 'appVersion',
      menuKey: 'appVersion',
      btnList: [
        {title: '新增', key: 'addbtn'},
        {title: '批量删除', key: 'batchDel'},
        {title: '下载二维码', key: 'download'},
        {title: '修改', key: 'edit'},
        {title: '删除', key: 'delete'}
      ],
      component: resolve => require(['../components/systemSet/appVersion/appVersion'], resolve),
      meta: {title: 'app版本管理', breadNumber: 0}
    },
    {
      path: '/appVersion/add',
      name: 'addVersion',
      menuKey: 'appVersion',
      btnList: [
        {title: '提交', key: 'submit'}
      ],
      component: resolve => require(['../components/systemSet/appVersion/addVersion'], resolve),
      meta: {title: '新增版本', breadNumber: 1}
    },
    {
      path: '/communityApp',
      name: 'communityApp',
      menuKey: 'communityApp',
      btnList: [
        {title: '新增', key: 'addbtn'},
        {title: '同步应用功能', key: 'sync'},
        {title: '状态切换', key: 'status'},
        {title: '修改', key: 'edit'},
        {title: '编辑功能', key: 'editFun'},
        {title: '删除', key: 'delete'}
      ],
      component: resolve => require(['../components/systemSet/communityApp/communityApp'], resolve),
      meta: {title: '社区app功能配置', breadNumber: 0}
    },
    {
      path: '/communityApp/add',
      name: 'addCommunityApp',
      menuKey: 'communityApp',
      btnList: [
        {title: '提交', key: 'submit'}
      ],
      component: resolve => require(['../components/systemSet/communityApp/addCommunityApp'], resolve),
      meta: {title: '新增社区app功能', breadNumber: 1}
    },
    {
      path: '/communityApp/fun',
      name: 'editCommunityFun',
      menuKey: 'communityApp',
      btnList: [
        {title: '添加功能', key: 'addbtn'},
        {title: '状态切换', key: 'status'},
        {title: '编辑', key: 'edit'},
        {title: '删除', key: 'delete'}
      ],
      component: resolve => require(['../components/systemSet/communityApp/editCommunityFun'], resolve),
      meta: {title: '编辑社区功能', breadNumber: 1}
    },

    {
      path: '/stewardApp',
      name: 'stewardApp',
      menuKey: 'stewardApp',
      btnList: [
        {title: '新增', key: 'addbtn'},
        {title: '同步应用功能', key: 'sync'},
        {title: '状态切换', key: 'status'},
        {title: '修改', key: 'edit'},
        {title: '编辑功能', key: 'editFun'},
        {title: '删除', key: 'delete'}
      ],
      component: resolve => require(['../components/systemSet/stewardApp/stewardApp'], resolve),
      meta: {title: '管家app功能配置', breadNumber: 0}
    },
    {
      path: '/stewardApp/add',
      name: 'addStewardApp',
      menuKey: 'stewardApp',
      btnList: [
        {title: '提交', key: 'submit'}
      ],
      component: resolve => require(['../components/systemSet/stewardApp/addStewardApp'], resolve),
      meta: {title: '新增管家功能', breadNumber: 1}
    },
    {
      path: '/stewardApp/fun',
      name: 'editStewardFun',
      menuKey: 'stewardApp',
      btnList: [
        {title: '添加功能', key: 'addbtn'},
        {title: '状态切换', key: 'status'},
        {title: '编辑', key: 'edit'},
        {title: '删除', key: 'delete'}
      ],
      component: resolve => require(['../components/systemSet/stewardApp/editStewardFun'], resolve),
      meta: {title: '编辑管家功能', breadNumber: 1}
    },
    {
      path: '/advert',
      name: 'advert',
      menuKey: 'advert',
      btnList: [
        {title: '新增', key: 'addbtn'},
        {title: '状态切换', key: 'status'},
        {title: '编辑', key: 'edit'},
        {title: '删除', key: 'delete'}
      ],
      component: resolve => require(['../components/marketing/advert/advert'], resolve),
      meta: {title: 'APP广告', breadNumber: 0}
    },
    {
      path: '/advert/add',
      name: 'addAdvert',
      menuKey: 'advert',
      btnList: [
        {title: '提交', key: 'submit'}
      ],
      component: resolve => require(['../components/marketing/advert/addAdvert'], resolve),
      meta: {title: '新增APP广告', breadNumber: 1}
    },
    {
      path: '/msgTemplate',
      name: 'msgTemplate',
      menuKey: 'msgTemplate',
      btnList: [
        {title: '新增', key: 'addbtn'},
        {title: '编辑', key: 'edit'},
        {title: '删除', key: 'delete'}
      ],
      component: resolve => require(['../components/marketing/msgTemplate/msgTemplate'], resolve),
      meta: {title: '消息模板', breadNumber: 0}
    },
    {
      path: '/msgTemplate/add',
      name: 'addMsgTemplate',
      menuKey: 'msgTemplate',
      btnList: [
        {title: '提交', key: 'submit'}
      ],
      component: resolve => require(['../components/marketing/msgTemplate/addMsgTemplate'], resolve),
      meta: {title: '添加模板', breadNumber: 1}
    },
    {
      path: '/push',
      name: 'push',
      menuKey: 'push',
      btnList: [
        {title: '新增', key: 'addbtn'},
        {title: '详情', key: 'detail'},
        {title: '撤回', key: 'cancel'}
      ],
      component: resolve => require(['../components/marketing/push/push'], resolve),
      meta: {title: '推送通知', breadNumber: 0}
    },
    {
      path: '/push/add',
      name: 'addPush',
      menuKey: 'push',
      btnList: [
        {title: '提交', key: 'submit'}
      ],
      component: resolve => require(['../components/marketing/push/addPush'], resolve),
      meta: {title: '新增推送', breadNumber: 1}
    },
    {
      path: '/push/detail',
      name: 'pushDetail',
      menuKey: 'push',
      component: resolve => require(['../components/marketing/push/pushDetail'], resolve),
      meta: {title: '推送详情', breadNumber: 1}
    },
    {
      path: '/systemMsg',
      name: 'systemMsg',
      menuKey: 'systemMsg',
      btnList: [
        {title: '新增', key: 'addbtn'},
        {title: '修改', key: 'edit'},
        {title: '删除', key: 'delete'}
      ],
      component: resolve => require(['../components/marketing/systemMsg/systemMsg'], resolve),
      meta: {title: '系统消息', breadNumber: 0}
    },
    {
      path: '/systemMsg/add',
      name: 'addSystemMsg',
      menuKey: 'systemMsg',
      btnList: [
        {title: '提交', key: 'submit'}
      ],
      component: resolve => require(['../components/marketing/systemMsg/addSystemMsg'], resolve),
      meta: {title: '新增系统消息', breadNumber: 1}
    },
    {
      path: '/feedBack',
      name: 'feedBack',
      menuKey: 'feedBack',
      btnList: [
        {title: '反馈内容', key: 'content'},
        {title: '回复详情', key: 'feedbackDetail'},
        {title: '回复', key: 'feedback'},
        {title: '删除', key: 'delete'}
      ],
      component: resolve => require(['../components/marketing/feedBack'], resolve),
      meta: {title: '用户反馈', breadNumber: 0}
    },
    {
      path: '/product',
      name: 'product',
      menuKey: 'product',
      btnList: [
        {title: '新增', key: 'addbtn'},
        {title: '修改', key: 'edit'},
        {title: '编辑功能', key: 'editFun'},
        {title: '初始化设备', key: 'init'},
        {title: '删除', key: 'delete'}
      ],
      component: resolve => require(['../components/device/product/product'], resolve),
      meta: {title: '产品列表', breadNumber: 0}
    },
    {
      path: '/product/add',
      name: 'addProduct',
      menuKey: 'product',
      btnList: [
        {title: '提交', key: 'submit'}
      ],
      component: resolve => require(['../components/device/product/addProduct'], resolve),
      meta: {title: '新增产品', breadNumber: 1}
    },
    {
      path: '/product/edit',
      name: 'editProduct',
      menuKey: 'product',
      btnList: [
        {title: '添加功能', key: 'addbtn'},
        {title: '修改', key: 'edit'},
        {title: '状态切换', key: 'status'},
        {title: '删除', key: 'delete'}
      ],
      component: resolve => require(['../components/device/product/editProduct'], resolve),
      meta: {title: '编辑功能', breadNumber: 1}
    },
    {
      path: '/device',
      name: 'device',
      menuKey: 'device',
      btnList: [
        {title: '新增', key: 'addbtn'},
        {title: '删除', key: 'batchDel'},
        {title: '导出', key: 'export'},
        {title: '修改', key: 'edit'},
        {title: '删除', key: 'delete'}
      ],
      component: resolve => require(['../components/device/device/device'], resolve),
      meta: {title: '设备', breadNumber: 0}
    },
    {
      path: '/device/add',
      name: 'addDevice',
      menuKey: 'device',
      btnList: [
        {title: '提交', key: 'submit'}
      ],
      component: resolve => require(['../components/device/device/addDevice'], resolve),
      meta: {title: '添加设备', breadNumber: 1}
    },
    {
      path: '/cardRecord',
      name: 'cardRecord',
      menuKey: 'cardRecord',
      btnList: [
        {title: '状态切换', key: 'status'},
        {title: '删除', key: 'delete'}
      ],
      component: resolve => require(['../components/device/cardRecord'], resolve),
      meta: {title: '制卡记录', breadNumber: 0}
    },
    {
      path: '/openLog',
      name: 'openLog',
      menuKey: 'openLog',
      btnList: [
        {title: '查看抓拍', key: 'show'}
      ],
      component: resolve => require(['../components/device/openLog'], resolve),
      meta: {title: '开门日志', breadNumber: 0}
    },

    {
      path: '/msgtplCate',
      name: 'msgtplCate',
      menuKey: 'msgtplCate',
      btnList: [
        {title: '新增', key: 'addbtn'},
        {title: '查看子类', key: 'showChildren'},
        {title: '添加子类', key: 'addChildren'},
        {title: '修改', key: 'edit'},
        {title: '删除', key: 'delete'}
      ],
      component: resolve => require(['../components/device/category/msgTpl/msgtplCate'], resolve),
      meta: {title: '消息分类', breadNumber: 0}
    },
    {
      path: '/msgtplCate/add',
      name: 'addMsgtplCate',
      menuKey: 'msgtplCate',
      btnList: [
        {title: '提交', key: 'submit'}
      ],
      component: resolve => require(['../components/device/category/msgTpl/addMsgtplCate'], resolve),
      meta: {title: '新增消息分类', breadNumber: 1}
    },

    {
      path: '/docCate',
      name: 'docCate',
      menuKey: 'docCate',
      btnList: [
        {title: '新增', key: 'addbtn'},
        {title: '查看子类', key: 'showChildren'},
        {title: '添加子类', key: 'addChildren'},
        {title: '修改', key: 'edit'},
        {title: '删除', key: 'delete'}
      ],
      component: resolve => require(['../components/device/category/doc/docCate'], resolve),
      meta: {title: '文档分类', breadNumber: 0}
    },
    {
      path: '/docCate/add',
      name: 'addDocCate',
      menuKey: 'docCate',
      btnList: [
        {title: '提交', key: 'submit'}
      ],
      component: resolve => require(['../components/device/category/doc/addDocCate'], resolve),
      meta: {title: '新增文档分类', breadNumber: 1}
    },

    {
      path: '/productCate',
      name: 'productCate',
      menuKey: 'productCate',
      btnList: [
        {title: '新增', key: 'addbtn'},
        {title: '查看子类', key: 'showChildren'},
        {title: '添加子类', key: 'addChildren'},
        {title: '修改', key: 'edit'},
        {title: '删除', key: 'delete'}
      ],
      component: resolve => require(['../components/device/category/product/productCate'], resolve),
      meta: {title: '产品分类', breadNumber: 0}
    },
    {
      path: '/productCate/add',
      name: 'addProductCate',
      menuKey: 'productCate',
      btnList: [
        {title: '提交', key: 'submit'}
      ],
      component: resolve => require(['../components/device/category/product/addProductCate'], resolve),
      meta: {title: '新增分类', breadNumber: 1}
    },
    {
      path: '/locationCate',
      name: 'locationCate',
      menuKey: 'locationCate',
      btnList: [
        {title: '新增', key: 'addbtn'},
        {title: '查看子类', key: 'showChildren'},
        {title: '添加子类', key: 'addChildren'},
        {title: '修改', key: 'edit'},
        {title: '删除', key: 'delete'}
      ],
      component: resolve => require(['../components/device/category/location/locationCate'], resolve),
      meta: {title: '位置分类', breadNumber: 0}
    },
    {
      path: '/locationCate/add',
      name: 'addLocationCate',
      menuKey: 'locationCate',
      btnList: [
        {title: '提交', key: 'submit'}
      ],
      component: resolve => require(['../components/device/category/location/addLocationCate'], resolve),
      meta: {title: '新增位置分类', breadNumber: 1}
    },

    {
      path: '/apiCate',
      name: 'apiCate',
      menuKey: 'apiCate',
      btnList: [
        {title: '新增', key: 'addbtn'},
        {title: '查看子类', key: 'showChildren'},
        {title: '添加子类', key: 'addChildren'},
        {title: '修改', key: 'edit'},
        {title: '删除', key: 'delete'}
      ],
      component: resolve => require(['../components/device/category/api/apiCate'], resolve),
      meta: {title: 'api分类', breadNumber: 0}
    },
    {
      path: '/apiCate/add',
      name: 'addApiCate',
      menuKey: 'apiCate',
      btnList: [
        {title: '提交', key: 'submit'}
      ],
      component: resolve => require(['../components/device/category/api/addApiCate'], resolve),
      meta: {title: '新增api分类', breadNumber: 1}
    },

    {
      path: '/api',
      name: 'api',
      menuKey: 'api',
      btnList: [
        {title: '新增', key: 'addbtn'},
        {title: '修改', key: 'edit'},
        {title: '删除', key: 'delete'}
      ],
      component: resolve => require(['../components/systemSet/api/api'], resolve),
      meta: {title: 'api管理', breadNumber: 0}
    },
    {
      path: '/api/add',
      name: 'addApi',
      menuKey: 'api',
      btnList: [
        {title: '提交', key: 'submit'}
      ],
      component: resolve => require(['../components/systemSet/api/addApi'], resolve),
      meta: {title: '新增api', breadNumber: 1}
    },
    {
      path: '/keyApply',
      name: 'keyApply',
      menuKey: 'keyApply',
      btnList: [
        {title: '审核', key: 'audit'},
        {title: '详情', key: 'detail'}
      ],
      component: resolve => require(['../components/device/keyApply/keyApply'], resolve),
      meta: {title: '钥匙申请', breadNumber: 0}
    },
    {
      path: '/keyApply/detail',
      name: 'keyApplyDetail',
      menuKey: 'keyApply',
      btnList: [
        {title: '通过', key: 'pass'},
        {title: '拒绝', key: 'reject'}
      ],
      component: resolve => require(['../components/device/keyApply/keyApplyDetail'], resolve),
      meta: {title: '钥匙申请详情', breadNumber: 1}
    },
    {
      path: '/keyList',
      name: 'keyList',
      menuKey: 'keyList',
      btnList: [
        {title: '分配钥匙', key: 'allocKey'},
        {title: '批量分配钥匙', key: 'bathAlloc'},
        {title: '批量删除', key: 'batchDel'},
        {title: '删除', key: 'delete'}
      ],
      component: resolve => require(['../components/device/keyList/keyList'], resolve),
      meta: {title: '住户钥匙列表', breadNumber: 0}
    },
    {
      path: '/keyList/alloc',
      name: 'allocation',
      menuKey: 'keyList',
      btnList: [
        {title: '提交', key: 'submit'}
      ],
      component: resolve => require(['../components/device/keyList/allocation'], resolve),
      meta: {title: '分配钥匙', breadNumber: 1}
    },
    {
      path: '/keyList/batchAlloc',
      name: 'batchAllocation',
      menuKey: 'keyList',
      btnList: [
        {title: '提交', key: 'submit'}
      ],
      component: resolve => require(['../components/device/keyList/batchAllocation'], resolve),
      meta: {title: '批量分配钥匙', breadNumber: 1}
    },
    {
      path: '/smartDoor',
      name: 'smartDoor',
      menuKey: 'smartDoor',
      btnList: [
        {title: '生成云对讲账户', key: 'createAccount'},
        {title: '批量删除', key: 'batchDel'},
        {title: '批量初始化设备', key: 'batchInit'},
        {title: '批量同步数据', key: 'reset'},
        {title: '批量同步人脸', key: 'syncFace'},
        {title: '详情', key: 'detail'},
        {title: '修改', key: 'edit'},
        {title: '初始化设备', key: 'init'},
        {title: '重启', key: 'restart'},
        {title: '升级', key: 'update'},
        {title: '删除', key: 'delete'},
        {title: '获取日志', key: 'log'},
        {title: '远程调试', key: 'debug'}
      ],
      component: resolve => require(['../components/device/smartDoor/smartDoor'], resolve),
      meta: {title: '门禁设备', breadNumber: 0}
    },
    {
      path: '/smartDoor/edit',
      name: 'editSmartDoor',
      menuKey: 'smartDoor',
      btnList: [
        {title: '修改设备名称', key: 'editDevName'},
        {title: '修改设备编码', key: 'editDevCode'},
        {title: '取消', key: 'cancel'},
        {title: '提交', key: 'submit'}
      ],
      component: resolve => require(['../components/device/smartDoor/editSmartDoor'], resolve),
      meta: {title: '编辑门禁设备', breadNumber: 1}
    },
    {
      path: '/smartDoor/detail',
      name: 'smartDoorDetail',
      menuKey: 'smartDoor',
      component: resolve => require(['../components/device/smartDoor/smartDoorDetail'], resolve),
      meta: {title: '门禁设备详情', breadNumber: 1}
    },
    {
      path: '/householdAuthRecord',
      name: 'householdAuthRecord',
      menuKey: 'householdAuthRecord',
      btnList: [
        {title: '审核', key: 'audit'},
        {title: '详情', key: 'detail'}
      ],
      component: resolve => require(['../components/member/householdAuthRecord/householdAuthRecord'], resolve),
      meta: {title: '住户认证记录', breadNumber: 0}
    },
    {
      path: '/householdAuthRecord/detail',
      name: 'householdAuthDetail',
      menuKey: 'householdAuthRecord',
      btnList: [
        {title: '通过', key: 'pass'},
        {title: '拒绝', key: 'reject'}
      ],
      component: resolve => require(['../components/member/householdAuthRecord/householdAuthDetail'], resolve),
      meta: {title: '住户认证详情', breadNumber: 1}
    },
    {
      path: '/passport',
      name: 'passport',
      menuKey: 'passport',
      btnList: [
        {title: '状态切换', key: 'status'}
      ],
      component: resolve => require(['../components/member/passport'], resolve),
      meta: {title: '社区身份证', breadNumber: 0}
    },
    {
      path: '/member',
      name: 'member',
      menuKey: 'member',
      btnList: [
        {title: '详情', key: 'detail'},
        {title: '住户信息', key: 'roomInfo'},
        {title: '状态切换', key: 'status'}
      ],
      component: resolve => require(['../components/member/memberInfo/member'], resolve),
      meta: {title: '会员信息', breadNumber: 0}
    },
    {
      path: '/member/detail',
      name: 'memberDetail',
      menuKey: 'member',
      component: resolve => require(['../components/member/memberInfo/memberDetail'], resolve),
      meta: {title: '会员详情', breadNumber: 1}
    },
    {
      path: '/member/housingInfo',
      name: 'housingInfo',
      menuKey: 'member',
      btnList: [
        {title: '添加', key: 'addbtn'},
        {title: '删除', key: 'delete'},
        {title: '续期', key: 'delay'}
      ],
      component: resolve => require(['../components/member/memberInfo/housingInfo'], resolve),
      meta: {title: '住房信息', breadNumber: 1}
    },
    {
      path: '/room',
      name: 'room',
      menuKey: 'room',
      btnList: [
        {title: '添加', key: 'addbtn'},
        {title: '批量删除', key: 'batchDel'},
        {title: '导入', key: 'import'},
        {title: '门卡信息', key: 'cardInfo'},
        {title: '住户信息', key: 'householdInfo'},
        {title: '修改', key: 'edit'},
        {title: '删除', key: 'delete'}
      ],
      component: resolve => require(['../components/baseData/room/room'], resolve),
      meta: {title: '房间管理', breadNumber: 0}
    },
    {
      path: '/room/info',
      name: 'roomInfo',
      menuKey: 'room',
      btnList: [
        {title: '删除', key: 'delete'},
        {title: '续期', key: 'delay'}
      ],
      component: resolve => require(['../components/baseData/room/roomInfo'], resolve),
      meta: {title: '住户信息', breadNumber: 1}
    },
    {
      path: '/room/add',
      name: 'addRoom',
      menuKey: 'room',
      btnList: [
        {title: '提交', key: 'submit'}
      ],
      component: resolve => require(['../components/baseData/room/addRoom'], resolve),
      meta: {title: '添加房间', breadNumber: 1}
    },
    {
      path: '/room/import',
      name: 'importRoom',
      menuKey: 'room',
      btnList: [
        {title: '下载模板', key: 'download'},
        {title: '提交', key: 'submit'}
      ],
      component: resolve => require(['../components/baseData/room/importRoom'], resolve),
      meta: {title: '导入房间', breadNumber: 1}
    },
    {
      path: '/room/card',
      name: 'cardInfo',
      menuKey: 'room',
      btnList: [],
      component: resolve => require(['../components/baseData/room/cardInfo'], resolve),
      meta: {title: '门卡信息', breadNumber: 1}
    },
    {
      path: '/location',
      name: 'location',
      menuKey: 'location',
      btnList: [
        {title: '新增', key: 'addbtn'},
        {title: '批量删除', key: 'batchDel'},
        {title: '修改', key: 'edit'},
        {title: '删除', key: 'delete'}
      ],
      component: resolve => require(['../components/baseData/location/location'], resolve),
      meta: {title: '位置管理', breadNumber: 0}
    },
    {
      path: '/location/add',
      name: 'addLocation',
      menuKey: 'location',
      btnList: [
        {title: '提交', key: 'submit'}
      ],
      component: resolve => require(['../components/baseData/location/addLocation'], resolve),
      meta: {title: '新增位置', breadNumber: 1}
    },
    {
      path: '/unit',
      name: 'unit',
      menuKey: 'unit',
      btnList: [
        {title: '新增', key: 'addbtn'},
        {title: '批量删除', key: 'batchDel'},
        {title: '修改', key: 'edit'},
        {title: '删除', key: 'delete'}
      ],
      component: resolve => require(['../components/baseData/unit/unit'], resolve),
      meta: {title: '单元管理', breadNumber: 0}
    },
    {
      path: '/addUnit',
      name: 'addUnit',
      menuKey: 'unit',
      btnList: [
        {title: '提交', key: 'submit'}
      ],
      component: resolve => require(['../components/baseData/unit/addUnit'], resolve),
      meta: {title: '添加单元', breadNumber: 1}
    },
    {
      path: '/propertyAccount',
      name: 'propertyAccount',
      menuKey: 'propertyAccount',
      btnList: [
        {title: '重置密码', key: 'resetPwd'},
        {title: '修改', key: 'edit'},
        {title: '删除', key: 'delete'}
      ],
      component: resolve => require(['../components/property/account/propertyAccount'], resolve),
      meta: {title: '物业账号管理', breadNumber: 0}
    },
    {
      path: '/propertyAccount/edit',
      name: 'editPropertyAccount',
      menuKey: 'propertyAccount',
      btnList: [
        {title: '提交', key: 'submit'}
      ],
      component: resolve => require(['../components/property/account/editPropertyAccount'], resolve),
      meta: {title: '编辑物业账号', breadNumber: 1}
    },
    {
      path: '/company',
      name: 'company',
      menuKey: 'company',
      btnList: [
        {title: '新增', key: 'addbtn'},
        {title: '审核', key: 'audit'},
        {title: '修改', key: 'edit'},
        {title: '删除', key: 'delete'}
      ],
      component: resolve => require(['../components/property/company/company'], resolve),
      meta: {title: '物业公司管理', breadNumber: 0}
    },
    {
      path: '/company/add',
      name: 'addCompany',
      menuKey: 'company',
      btnList: [
        {title: '确定', key: 'submit'}
      ],
      component: resolve => require(['../components/property/company/addCompany'], resolve),
      meta: {title: '新增物业公司', breadNumber: 1}
    },
    {
      path: '/company/audit',
      name: 'auditCompany',
      menuKey: 'company',
      btnList: [
        {title: '通过', key: 'pass'},
        {title: '拒绝', key: 'reject'}
      ],
      component: resolve => require(['../components/property/company/auditCompany'], resolve),
      meta: {title: '物业公司审核', breadNumber: 1}
    },
    {
      path: '/propertyRole',
      name: 'propertyRole',
      menuKey: 'propertyRole',
      component: resolve => require(['../components/property/role/propertyRole'], resolve),
      btnList: [
        {title: '新增', key: 'addbtn'},
        {title: 'API权限', key: 'apiAuth'},
        {title: '视图权限', key: 'viewAuth'},
        {title: '修改', key: 'edit'},
        {title: '删除', key: 'delete'}
      ],
      meta: {title: '物业角色', breadNumber: 0}
    },
    {
      path: '/propertyRole/add',
      name: 'propertyAddRole',
      menuKey: 'propertyRole',
      component: resolve => require(['../components/property/role/propertyAddRole'], resolve),
      btnList: [
        {title: '提交', key: 'submit'}
      ],
      meta: {title: '新增物业角色', breadNumber: 1}
    },
    {
      path: '/propertyRole/api',
      name: 'propertyApiAuth',
      menuKey: 'propertyRole',
      btnList: [
        {title: '提交', key: 'submit'}
      ],
      component: resolve => require(['../components/managerCenter/role/roleAuth'], resolve),
      meta: {title: '物业角色API权限', breadNumber: 1}
    },
    {
      path: '/propertyRole/view',
      name: 'propertyViewAuth',
      menuKey: 'propertyRole',
      btnList: [
        {title: '提交', key: 'submit'}
      ],
      component: resolve => require(['../components/managerCenter/role/roleAuth'], resolve),
      meta: {title: '物业角色视图权限', breadNumber: 1}
    },
    {
      path: '/community',
      name: 'community',
      menuKey: 'community',
      btnList: [
        {title: '新增', key: 'addbtn'},
        {title: '批量删除', key: 'batchDel'},
        {title: '小区配置', key: 'config'},
        {title: '修改', key: 'edit'},
        {title: '删除', key: 'delete'}
      ],
      component: resolve => require(['../components/baseData/community/community'], resolve),
      meta: {title: '小区管理', breadNumber: 0}
    },
    {
      path: '/community/add',
      name: 'addCommunity',
      menuKey: 'community',
      btnList: [
        {title: '新增', key: 'submit'}
      ],
      component: resolve => require(['../components/baseData/community/addCommunity'], resolve),
      meta: {title: '新增小区', breadNumber: 1}
    },
    {
      path: '/community/config',
      name: 'communityConfig',
      menuKey: 'community',
      btnList: [
        {title: '新增', key: 'submit'}
      ],
      component: resolve => require(['../components/baseData/community/communityConfig'], resolve),
      meta: {title: '小区配置', breadNumber: 1}
    },
    {
      path: '/building',
      name: 'building',
      menuKey: 'building',
      btnList: [
        {title: '新增', key: 'addbtn'},
        {title: '批量删除', key: 'batchDel'},
        {title: '修改', key: 'edit'},
        {title: '删除', key: 'delete'}
      ],
      component: resolve => require(['../components/baseData/building/building'], resolve),
      meta: {title: '楼栋管理', breadNumber: 0}
    },
    {
      path: '/building/add',
      name: 'addBuilding',
      menuKey: 'building',
      btnList: [
        {title: '提交', key: 'submit'}
      ],
      component: resolve => require(['../components/baseData/building/addBuilding'], resolve),
      meta: {title: '新增楼栋', breadNumber: 1}
    },
    {
      path: '/role',
      name: 'role',
      menuKey: 'role',
      btnList: [
        {title: '新增', key: 'addbtn'},
        {title: '批量删除', key: 'batchDel'},
        {title: 'API权限', key: 'apiAuth'},
        {title: 'API权限', key: 'viewAuth'},
        {title: '修改', key: 'edit'},
        {title: '删除', key: 'delete'}
      ],
      component: resolve => require(['../components/managerCenter/role/role'], resolve),
      meta: {title: '管理员角色管理', breadNumber: 0}
    },
    {
      path: '/role/add',
      name: 'addRole',
      menuKey: 'role',
      btnList: [
        {title: '提交', key: 'submit'}
      ],
      component: resolve => require(['../components/managerCenter/role/addRole'], resolve),
      meta: {title: '新增管理员角色', breadNumber: 1}
    },
    {
      path: '/role/api',
      name: 'manageApiAuth',
      menuKey: 'role',
      btnList: [
        {title: '提交', key: 'submit'}
      ],
      component: resolve => require(['../components/managerCenter/role/roleAuth'], resolve),
      meta: {title: '配置API权限', breadNumber: 1}
    },
    {
      path: '/role/view',
      name: 'manageViewAuth',
      menuKey: 'role',
      btnList: [
        {title: '提交', key: 'submit'}
      ],
      component: resolve => require(['../components/managerCenter/role/roleAuth'], resolve),
      meta: {title: '配置视图权限', breadNumber: 1}
    },
    {
      path: '/account',
      name: 'account',
      menuKey: 'account',
      btnList: [
        {title: '新增', key: 'addbtn'},
        {title: '批量删除', key: 'batchDel'},
        {title: '状态切换', key: 'status'},
        {title: '重置密码', key: 'resetPwd'},
        {title: '修改', key: 'edit'},
        {title: '删除', key: 'delete'}
      ],
      component: resolve => require(['../components/managerCenter/account/account'], resolve),
      meta: {title: '管理员账号管理', breadNumber: 0}
    },
    {
      path: '/account/add',
      name: 'addAccount',
      menuKey: 'account',
      btnList: [
        {title: '提交', key: 'submit'}
      ],
      component: resolve => require(['../components/managerCenter/account/addAccount'], resolve),
      meta: {title: '新增管理员账号', breadNumber: 1}
    },
    {
      path: '/operationLog',
      name: 'operationLog',
      menuKey: 'operationLog',
      btnList: [
        {title: '账号详情', key: 'accountDetail'}
      ],
      component: resolve => require(['../components/managerCenter/operationLog'], resolve),
      meta: {title: '管理员操作日志', breadNumber: 0}
    },
    {
      path: '*',
      name: 'noPage',
      component: resolve => require(['../components/noPage'], resolve)
    }
  ]
};



// WEBPACK FOOTER //
// ./src/js/menuRoutes.js